import(/* webpackMode: "eager" */ "/app/fe-webapp-next/app/error.tsx");
